import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
export function FinalCTA() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-15" data-mp="c6iw5y1c0999">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16" data-mp="c8c0h6oh2he3">
        <div className="relative rounded-3xl overflow-hidden bg-[#141B3A] border border-[#1E293B] p-8 md:p-16 text-center" data-id="element-17" data-mp="84nqyiga5bq7">
          {/* Background Gradient */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-18" data-mp="m2ltmql8njpv">
            <div className="absolute top-[-50%] left-[20%] w-[600px] h-[600px] bg-[#FF5722]/10 rounded-full blur-[100px]" data-id="element-19" data-mp="h3rdxxikib9z" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-20" data-mp="qv57zprr2ivq">
            Ready to Transform Your Sales?
          </h2>
          <p className="text-lg text-[#94A3B8] mb-10 max-w-2xl mx-auto" data-id="element-21" data-mp="14w7xydlv8dbx">
            Let's analyze how we can optimize your CRM system in a free initial
            consultation.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10" data-id="element-22" data-mp="2c5yb9rdqspfh">
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-23" data-mp="2h4sqykgexxvd">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-24" data-mp="2m340eu2sq6d2" />
              <span data-id="element-25" data-mp="2m4x9sh4sn4or">Free Initial Consultation (30 Min)</span>
            </div>
            <div className="hidden sm:block text-[#334155]" data-id="element-26" data-mp="2r3iccn7iq0gd">•</div>
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-27" data-mp="2v4allgge45cn">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-28" data-mp="302lv1q2rwduc" />
              <span data-id="element-29" data-mp="30110w1kdewx0">Concrete Optimization Suggestions</span>
            </div>
            <div className="hidden sm:block text-[#334155]" data-id="element-30" data-mp="34uddtefotf9x">•</div>
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-31" data-mp="39s5g92dykjsd">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-32" data-mp="39uhsr00y61y1" />
              <span data-id="element-33" data-mp="3est45f6w4kid">No Obligations</span>
            </div>
          </div>

          <Button size="lg" className="w-full sm:w-auto text-lg px-10 py-4" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-35" data-mp="1jnjwpshlj2ls" />} onClick={openCalendlyPopup} data-id="element-34" data-mp="3islhe578beu2">
            Book Free Consultation Now
          </Button>

          <p className="mt-6 text-sm text-[#64748B]" data-id="element-36" data-mp="1enfi68090hy7">
            Limited to 5 consultations per week for maximum quality.
          </p>
        </div>
      </div>
    </section>;
}